import React from "react";
import { Link } from "react-router-dom";
import { colors } from "../../theme";
import "./landingPage-view.css";
import Footer from "./footer";

class HomeView extends React.Component {
  state = {
    activeFeature: 0,
  };

  scrollToTop = () => window.scrollTo(0, 0);

  render() {
    const features = [
      {
        title: "Appointment Management",
        description:
          "Streamline your scheduling with smart appointment management, automatic invoicing, and route optimization.",
        icon: "fas fa-calendar-alt",
      },
      {
        title: "Financial Tracking",
        description:
          "Keep your finances in check with comprehensive expense tracking, invoice management, and financial reporting.",
        icon: "fas fa-chart-line",
      },
      {
        title: "Vehicle Management",
        description:
          "Efficiently track business and private mileage, generate logbooks, and manage vehicle expenses.",
        icon: "fas fa-car",
      },
      {
        title: "Client Management",
        description:
          "Build stronger client relationships with custom templates, automated communications, and detailed client profiles.",
        icon: "fas fa-users",
      },
    ];

    return (
      <section>
        {/* Navigation */}
        <nav
          className="main-header navbar navbar-expand-md navbar-light navbar-white"
          style={{ marginLeft: 0 }}
        >
          <div className="container">
            <a href="/" className="navbar-brand">
              <img
                src="/moneyapp_blue.png"
                alt="MoneyApp Logo"
                style={{ marginRight: 15, height: 40 }}
              />
            </a>
            <ul className="order-1 order-md-3 navbar-nav navbar-no-expand ml-auto">
              <li className="nav-item mr-2">
                <Link to="/login" className="btn inverse btn-outline-danger">
                  Sign In
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/register" className="btn btn-primary" style={{ color: '#fff' }}>
                  Register
                </Link>
              </li>
            </ul>
          </div>
        </nav>

        {/* Hero Section */}
        <div
          className="hero-section"
          style={{
            backgroundImage: "url('/header.jpg')",
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="hero-overlay">
            <div className="container">
              <h1>Streamline Your Business Operations</h1>
              <p className="lead">
                From appointments to accounting, MoneyApp helps small businesses
                manage everything in one place
              </p>
              <div className="cta-buttons">
                <Link to="/register" className="btn btn-primary btn-lg">
                  Get Started
                </Link>
                <a
                  href="#pricing"
                  className="btn btn-outline-light btn-lg ml-3"
                >
                  View Pricing
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Features Section */}
        <div id="features" className="features-section">
          <div className="container">
            <h2 className="section-title">
              Everything You Need to Run Your Business
            </h2>
            <div className="row">
              {features.map((feature, index) => (
                <div key={index} className="col-md-3 col-sm-6">
                  <div className="feature-card">
                    <i className={feature.icon}></i>
                    <h3>{feature.title}</h3>
                    <p>{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* How It Works Section */}
        <div className="how-it-works-section">
          <div className="container">
            <h2 className="section-title">How MoneyApp Works</h2>
            <div className="steps">
              <div className="step">
                <div className="step-number">1</div>
                <h3>Create Your Account</h3>
                <p>Sign up and set up your business profile in minutes</p>
              </div>
              <div className="step">
                <div className="step-number">2</div>
                <h3>Customize Your Workflow</h3>
                <p>
                  Configure your appointment types, invoice templates, and
                  client settings
                </p>
              </div>
              <div className="step">
                <div className="step-number">3</div>
                <h3>Start Managing</h3>
                <p>
                  Begin scheduling appointments, tracking expenses, and managing
                  your business
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="testimonials-section">
          <div className="container">
            <h2 className="section-title">Built for Small Business</h2>
            <div className="testimonials">
              <div className="testimonial">
                <i className="fas fa-mobile-alt" style={{ fontSize: '2rem', color: '#007bff', marginBottom: '1rem' }}></i>
                <p>
                  Manage your business from anywhere — mobile app and web dashboard keep you in control on the go.
                </p>
              </div>
              <div className="testimonial">
                <i className="fas fa-bolt" style={{ fontSize: '2rem', color: '#007bff', marginBottom: '1rem' }}></i>
                <p>
                  Automate invoicing, expense tracking, and appointment scheduling — spend less time on admin.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Pricing Section */}
        <div id="pricing" className="pricing-section">
          <div className="container">
            <h2 className="section-title">Simple, Transparent Pricing</h2>
            <p className="section-subtitle">Start free, upgrade when you're ready</p>
            <div className="row justify-content-center">
              <div className="col-md-4 col-sm-6 mb-4">
                <div className="pricing-card">
                  <h3>Free</h3>
                  <div className="pricing-price">R0<span>/month</span></div>
                  <ul className="pricing-features">
                    <li><i className="fas fa-check"></i> 1 Company</li>
                    <li><i className="fas fa-check"></i> Appointments & Calendar</li>
                    <li><i className="fas fa-check"></i> Basic Invoicing</li>
                    <li><i className="fas fa-check"></i> Client Management</li>
                    <li><i className="fas fa-check"></i> Expense Tracking</li>
                  </ul>
                  <Link to="/register" className="btn btn-outline-primary btn-block">
                    Get Started
                  </Link>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 mb-4">
                <div className="pricing-card featured">
                  <div className="pricing-badge">Popular</div>
                  <h3>Pro</h3>
                  <div className="pricing-price">R199<span>/month</span></div>
                  <ul className="pricing-features">
                    <li><i className="fas fa-check"></i> Unlimited Companies</li>
                    <li><i className="fas fa-check"></i> AI Template Setup</li>
                    <li><i className="fas fa-check"></i> Recurring Invoices</li>
                    <li><i className="fas fa-check"></i> Vehicle Logbook</li>
                    <li><i className="fas fa-check"></i> Advanced Reporting</li>
                    <li><i className="fas fa-check"></i> Priority Support</li>
                  </ul>
                  <Link to="/register" className="btn btn-primary btn-block">
                    Start Free Trial
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="cta-section">
          <div className="container">
            <h2>Ready to Transform Your Business?</h2>
            <p>Simplify your business management today</p>
            <Link to="/register" className="btn btn-primary btn-lg">
              Get Started
            </Link>
          </div>
        </div>

        <Footer />
      </section>
    );
  }
}

export default HomeView;
